import { Inject } from '@odinjs/odin';

import { Endpoint, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { FieldAPI, FormAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnCancel, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';
import { SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, msg } from '@philips-emr/tws-core/lib/services';
import { format } from '@philips-emr/tws-core/lib/services/model-service';

import BaseController from './BaseController';

@Controller({ fragment: 'alterar-data-validade' })
export default class AlterarDataValidadeController extends BaseController {

  @Inject('SubmittableFragmentContext')
  private submittableFragmentContext: SubmittableFragmentContext;
  @Inject('field-notification')
  private fieldNotification: FieldAPI;
  @Inject('toast-notification')
  private toastNotification: ToastNotificationAPI;

  @OnSubmit({ target: 'form-alterar' })
  onSubmit(event: SubmitEvent): void {
    const api = event.target as FormAPI;
    const { nrSeqContrato, nrSeqAuditoria } = this.historyService.getCurrentRouteParams();

    this.fieldNotification.setVisible(false);
    if (api.isValid()) {

      void HttpService.put<string>(Endpoint.PUT.ALTERAR_DATA_VALIDADE, { nrSeqContrato, nrSeqAuditoria, ...api.getRecord() })
        .then(responde => {
          if (responde && responde.body) {
            ToastServiceStipulator.success(msg(responde.body));
            this.submittableFragmentContext.submit(event);
          }
        })
        .catch(ex => {
          this.fieldNotification.setVisible(true);

          if (ex && ex.body) {
            if (Array.isArray(ex.body)) {
              const aviso = msg(ex.body[0]);
              this.toastNotification.setMessage(aviso.replace('#@DT_LIMITE#@', format('date', ex.body[1], { type: 'shortDate' })));
            } else {
              this.toastNotification.setMessage(msg(ex.body));
            }
          }
        });
    }
  }

  @OnCancel({ target: 'form-alterar' })
  onCancel(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }
}
